export class BrandPass {
    expiry_text: string;
    constructor(product) {
        Object.assign(this, product);
        const expiry_in_month = Math.floor(product.validity / 30);
        this.expiry_text = `${expiry_in_month} months`;
    }
}
